module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-wrapper"
  }, [_c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("Other")]), _vm._v(" "), _c('div', {
    staticClass: "layer2"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "grid-container grid-100"
    }, [_c('div', {
      staticClass: "grid-100 ondemand-main",
      style: ({
        backgroundImage: ("url('" + (item.image.guid) + "')")
      })
    }, [_c('div', {
      staticClass: "other-copy white",
      attrs: {
        "data-v-966b223c": ""
      }
    }, [_c('h4', {
      staticClass: "title",
      attrs: {
        "data-v-966b223c": ""
      }
    }, [_vm._v(_vm._s(item.title.rendered))]), _c('p', [_vm._v(_vm._s(item.sub_title))]), _vm._v(" "), _c('p', [_vm._v(" ")])])]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "other-copy-mobile black",
      attrs: {
        "data-v-966b223c": ""
      }
    }, [_c('h4', {
      staticClass: "title",
      attrs: {
        "data-v-966b223c": ""
      }
    }, [_vm._v(_vm._s(item.title.rendered))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.sub_title))]), _vm._v(" "), _c('p', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video-item grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video-header grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video"
    }, [_c('iframe', {
      attrs: {
        "id": "main-video",
        "width": "560",
        "height": "315",
        "src": item.video_id_url,
        "frameborder": "0",
        "allowfullscreen": ""
      }
    })])])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-100 other-img-mobile"
  }, [_c('img', {
    attrs: {
      "src": "https://tools.mercedes-benz.co.uk/current/utilities/rn/other.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6551f76e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Other.vue
// module id = 285
// module chunks = 0